var map = {
	"./Bachelor Party - 13 - 1080_1080.webp": 1700,
	"./Barat - 11 - 1080_1080.webp": 5894,
	"./Carnival Party - 9 - 1080_1080.webp": 9531,
	"./Destination Wedding - 1 - 1080_1080.webp": 9703,
	"./Haldi Function - 7 - 1080_1080.webp": 4365,
	"./Kankotri Lekhan - 3 - 1080_1080.webp": 3093,
	"./Mehndi Function - 12 - 1080_1080.webp": 5636,
	"./Pre-Wedding - 10 - 1080_1080.webp": 2545,
	"./Reception Function - 11 - 1080_1080.webp": 1605,
	"./Ring Ceremony - 3 - 1080_1080.webp": 1959,
	"./Sangeet Sandhya - 9 - 1080_1080.webp": 2760,
	"./Wedding Event Banner - 35 - 1920_1080.webp": 5347,
	"./Wedding Function - 9 - 1080_1080.webp": 7481,
	"./Why Choose Panthi Event - 15 - 1280_720.webp": 9267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6379;